export enum HorizontalAlignment {
	none = 'NONE',
	left = 'LEFT',
	right = 'RIGHT',
	center = 'CENTER'
}
